export default "__VITE_ASSET__f9ec9032__"